import { type FC, type ReactNode, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useForm } from 'react-final-form';
import { stylesheet } from 'typestyle';
import * as tokens from '../../../resources/tokens';
import type { CampaignFormValues } from '../campaign.types';
import { CampaignErrors } from './CampaignErrors';
import type { CampaignErrorMessages } from './CampaignErrorsTypes';
import { CampaignSidebar } from './CampaignSidebar';

const css = stylesheet({
  'form-container': {
    overflow: 'hidden',
  },
  'main-container': {
    marginBottom: tokens.sizes.medium,
    marginTop: tokens.sizes.medium,
  },
  'main-content': {
    ...tokens.composites.cardShadow,
    background: tokens.colors.white,
    padding: tokens.sizes.large,
  },
  'side-bar': {
    position: 'fixed',
  },
});

export type CampaignFormProps = {
  campaignQueryPolling: () => void;
  children?: ReactNode;
};

export const CampaignForm: FC<CampaignFormProps> = ({ children, campaignQueryPolling }) => {
  const [errors, setErrors] = useState<CampaignErrorMessages>([]);
  const [sidebarErrors, setSidebarErrors] = useState<CampaignErrorMessages>([]);
  const form = useForm<CampaignFormValues>();
  const config = form.getState().values.config;
  const backendErrors = form.getState().values.campaign.errors;

  useEffect(() => {
    const campaignErrorMessages: CampaignErrorMessages = sidebarErrors;
    if (backendErrors) {
      backendErrors.map((error) => {
        campaignErrorMessages.push({
          message: error,
        });
      });
    }
    setErrors(campaignErrorMessages);
  }, [
    backendErrors,
    sidebarErrors,
  ]);

  return (
    <Row className={css['main-container']}>
      <Col xs={9}>
        <div className={css['main-content']}>
          <CampaignErrors errors={errors} />
          <h3>{config.title}</h3>
          <div className={css['form-container']}>
            <form id="sac-form">{children ? children : JSON.stringify(form.getState().values)}</form>
          </div>
        </div>
      </Col>
      <Col>
        <div className={css['side-bar']}>
          <CampaignSidebar campaignQueryPolling={campaignQueryPolling} onError={setSidebarErrors} />
        </div>
      </Col>
    </Row>
  );
};
